import { resolveModules } from "../model/modules.js";
import { verifiedEnvelope } from "./checksum.js";
import { deserializeCheckpoint } from "./deserialize.js";
import { migrateEnvelope, } from "./migrations.js";
import { serializeCheckpoint } from "./serialize.js";
export function createSaveCodec(definition, configuration, compatibility = {}) {
    validateConfiguration(configuration);
    const normalized = { ...configuration, modules: resolveModules(configuration.modules ?? []) };
    const maximumBytes = normalized.maximumBytes ?? 5 * 1024 * 1024;
    const inspect = (raw) => {
        const envelope = verifiedEnvelope(raw, maximumBytes);
        const migrated = migrateEnvelope(envelope, normalized.stateSchemaVersion, definition.simulationVersion, compatibility.migrations ?? [], compatibility.pendingTransitions ?? []);
        validateInstalledContent(migrated, normalized);
        return migrated;
    };
    return Object.freeze({
        encode: (snapshot, metadata) => JSON.stringify(serializeCheckpoint(definition, normalized, snapshot, metadata)),
        decode: (raw) => deserializeCheckpoint(definition, inspect(raw)),
        inspect,
    });
}
function validateInstalledContent(envelope, configuration) {
    if (envelope.content.version !== configuration.contentVersion ||
        envelope.content.digest !== configuration.contentDigest ||
        envelope.simulation.scheduleVersion !== (configuration.scheduleVersion ?? 1) ||
        JSON.stringify(envelope.content.modules) !== JSON.stringify(configuration.modules ?? [])) {
        throw new TypeError("Save content requires an explicit migration");
    }
}
function validateConfiguration(configuration) {
    if (!Number.isSafeInteger(configuration.stateSchemaVersion) ||
        configuration.stateSchemaVersion < 1)
        throw new TypeError("State schema version must be a positive safe integer");
    if (!configuration.contentVersion || !configuration.contentDigest)
        throw new TypeError("Content version and digest are required");
    if (configuration.maximumBytes !== undefined &&
        (!Number.isSafeInteger(configuration.maximumBytes) || configuration.maximumBytes < 1)) {
        throw new TypeError("Save size limit must be a positive safe integer");
    }
}
//# sourceMappingURL=codec.js.map